import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '@b2b/env/environment';
import { Country } from '@sparro/app/core/models/location.model';
import { Discipline } from '@sparro/app/core/models/supertag.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private baseUrl = `${environment.baseUrl}`;
  searchedDiscipline: any;

  disciplines_initialized = new BehaviorSubject(false);
  disciplines: BehaviorSubject<Discipline[]>;

  locations_initialized = new BehaviorSubject(false);
  locations: BehaviorSubject<Country[]>;

  searchByDisciplineInitialized = new BehaviorSubject(false);
  searchedDisciplines: BehaviorSubject<Discipline[]>;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`;
  }

  initializeDisciplines(disciplines: Discipline[]) {
    this.disciplines = new BehaviorSubject(disciplines);
    this.disciplines_initialized.next(true);
  }

  initializeLocations(countries: Country[]) {
    this.locations = new BehaviorSubject(countries);
    this.locations_initialized.next(true);
  }

  initializeSearchByDiscipline(disciplines: Discipline[]) {
    this.searchedDisciplines = new BehaviorSubject(disciplines);
    this.searchByDisciplineInitialized.next(true);
  }

  getFilteredCountries() {
    return this.http.get(this.baseUrl + 'countries/?competition=True');
  }

  getFilteredDisciplines() {
    return this.http.get(this.baseUrl + 'competitions/disciplines/');
  }

  getFilteredTags() {
    return this.http.get(this.baseUrl + 'competitions/tags/?type=Tag');
  }

  getCompetitions() {
    return this.http.get(this.baseUrl + 'competitions/');
  }

  getPromotedCompetitions() {
    return this.http.get(this.baseUrl + 'competitions/promoted/');
  }

  getNonPromotedCompetitions() {
    return this.http.get(this.baseUrl + 'competitions/non_promoted/');
  }

  // Todo: Replace this code via subject code in FE
  setSearchDiscipline(discipline: Discipline) {
    this.searchedDiscipline = discipline;
  }

  getSearchDiscipline() {
    return this.searchedDiscipline;
  }

  getFilteredResults(
    page: number,
    search_text: string,
    discipline_ids: string,
    tag_ids: string,
    country_iso_codes: string,
    urlSubstring: string,
    order: string,
    show: string,
    registrationDateRange: string,
    submissionDateRange: string,
    organization_title: string,
    editorial: boolean
  ) {
    return this.http.get(
      this.baseUrl +
      'competitions' + (urlSubstring ? ('/' + urlSubstring) : ('')) + '/?page=' +
      page +
      '&search=' +
      search_text +
      '&disciplines=' +
      discipline_ids +
      '&tags=' +
      tag_ids +
      // '&location=' +
      // location_id +
      '&countries=' +
      country_iso_codes +
      '&ordering=' +
      order +
      '&hosted=' +
      show +
      '&registration_date_range=' +
      registrationDateRange +
      '&submission_date_range=' +
      submissionDateRange +
      '&organization_title=' +
      organization_title +
      '&editorial=' +
      (editorial ? true : '')
    );
  }
}
